import React from 'react'
import { AuthenticationStep } from './screens'

const Authentication = AuthenticationStep

export default Authentication
